import { css } from "../../../component-styles";

export const warm = css`
  :host {
    --bg: #f5f0e8;
    --bg-elevated: #f5f0e8;
    --text-pri: #1a1a18;
    --text-sec: #6b6860;
    --text-ter: #9b9890;
    --divider: rgba(0, 0, 0, 0.08);
    --hover-color: rgba(0, 0, 0, 0.04);
    --blue: #2563eb;
  }
`;
